module.exports = __webpack_public_path__ + "static/media/468x60_0079_ru.e81502d3.png";